import { render, staticRenderFns } from "./Poseta.vue?vue&type=template&id=0d49224d&scoped=true&"
import script from "./Poseta.vue?vue&type=script&lang=ts&"
export * from "./Poseta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49224d",
  null
  
)

export default component.exports